import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { ReactComponent as RMLogo } from "../Images/RM logo_blue.svg";
import { ReactComponent as IconAlarmClicked } from "../Images/icon_alarm_clicked.svg";
import { ReactComponent as IconAlarmDefault } from "../Images/icon_alarm_default.svg";
import { ReactComponent as IconProfile } from "../Images/icon_profile.svg";
import { ReactComponent as IconProfileClicked } from "../Images/icon_profile_clicked.svg";
import AlarmModal from "../Modals/AlarmModal";
import ProfileModal from "../Modals/ProfileModal.jsx";
import { useGoToAddr } from "../Utils/navigationUtils.js";
import { getDashboardResolvedLogoSrc } from "../Utils/sessionUtils.js";

const Header = ({ handleClick_setting }) => {
  const [profileClicked, setProfileClicked] = useState(false);
  const [alarmClicked, setAlarmClicked] = useState(false);
  const [logoSrc, setLogoSrc] = useState(() => getDashboardResolvedLogoSrc());
  const profileRef = useRef(null);
  const alarmRef = useRef(null);
  const goToAddr = useGoToAddr();

  const handleProfileClick = () => {
    setAlarmClicked(false);
    setProfileClicked(!profileClicked);
  };

  const handleAlarmClick = () => {
    setProfileClicked(false);
    setAlarmClicked(!alarmClicked);
  };
  const handleClickOutside = (e) => {
    if (profileRef.current && !profileRef.current.contains(e.target)) {
      setProfileClicked(false);
    }
    if (alarmRef.current && !alarmRef.current.contains(e.target)) {
      setAlarmClicked(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setLogoSrc(getDashboardResolvedLogoSrc());
  }, []);

  return (
    <HeaderBox>
      {logoSrc ? (
        <div style={{ width: "210px", height: "50px" }} className="logo">
          <img
            src={logoSrc}
            style={{
              width: "100%",
              height: "100%",
            }}
            onClick={() => goToAddr("home")}
          />
        </div>
      ) : (
        <RMLogo
          className="logo"
          onClick={() => goToAddr("home")}
          style={{ cursor: "pointer" }}
        />
      )}
      {/* <div className="messageBox">
        <IconInfoRed style={{ marginLeft: "20px" }} />
        <p className="infoText">
          기프티콘 서비스 이용시 '기업정보{">"}기프티콘'에서 챌린지와 기프티콘을
          꼭 설정해주세요!
        </p>
      </div>
      {alarmClicked ? (
        <div
          style={{
            marginLeft: "auto",
            width: "40px",
            height: "40px",
            borderRadius: "8px",
            backgroundColor: "#f5f5f5",
            cursor: "pointer",
          }}
        >
          <IconAlarmClicked onClick={handleAlarmClick} />
        </div>
      ) : (
        <IconAlarmActive
          style={{ marginLeft: "auto", cursor: "pointer" }}
          onClick={handleAlarmClick}
        />
      )}
      {alarmClicked && <AlarmModal ref={alarmRef} />} */}

      <div
        style={{ marginLeft: "auto", cursor: "pointer" }}
        onClick={handleAlarmClick}
      >
        {alarmClicked ? <IconAlarmClicked /> : <IconAlarmDefault />}
        <div style={{ position: "absolute", marginLeft: "-320px" }}>
          {alarmClicked && <AlarmModal />}
        </div>
      </div>

      <div
        style={{ marginLeft: "30px", marginRight: "30px", cursor: "pointer" }}
        onClick={handleProfileClick}
      >
        {profileClicked ? <IconProfileClicked /> : <IconProfile />}
        <div style={{ position: "absolute", marginLeft: "-250px" }}>
          {profileClicked && (
            <ProfileModal handleClick_setting={handleClick_setting} />
          )}
        </div>
      </div>
    </HeaderBox>
  );
};

const HeaderBox = styled.div`
  width: 100%;
  height: 80px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  position: fixed;
  z-index: 5;
  .logo {
    position: absolute;
    margin-left: 30px;
    cursor: pointer;
  }
  .messageBox {
    width: 652px;
    height: 42px;
    margin-left: 1088px;
    border-radius: 6px;
    background-color: #feefef;
    display: flex;
    align-items: center;
  }
  .infoText {
    font-family: "notoSans-medium";
    font-size: 16px;
    color: #222222;
    margin-left: 8px;
  }
`;

export default Header;
